import styled from "styled-components";

export const StyledContentWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 2rem 3rem;
`;
export const StyledAttrBtnGroupWrap = styled.div`
  margin-bottom: 2rem;
  margin-top: 2rem;
`;
